// import { MicroPhone } from "../../../../core/icons/Microphone";
import { Emoticon } from "../../../../core/icons/Emoticon";
import EmojiPicker, { EmojiStyle } from "emoji-picker-react";
import { XCloseGray } from "../../../../core/icons/XClose";
import { Row } from "../../../../core/components/Row";
import { useEffect, useRef, useState } from "react";
import { SendMessage } from "../../../../core/icons/SendMessage";
// import { CameraPublic } from "../../../../core/icons/Camera";
import { Picture } from "../../../../core/icons/Picture";
import { DropDown } from "../../../../core/components/DropDown";
import { Column } from "../../../../core/components/Column";
import { TextComponent } from "../../../../core/components/TextComponent";
import { Time, TimeBG } from "../../../../core/icons/Time";
import { CustomButton } from "../../../../core/components/CustomButton";
import { compressImage, validateField } from "../../../../core/constants/constants";
import { CameraPublic } from "../../../../core/icons/Camera";

export const FooterChat = ({ onSendMessage, text, setText, isTemp, setIsTemp, handleMessagePhoto }:
    {
        onSendMessage: () => void,
        handleMessagePhoto: () => void,
        text: string | File,
        setText: React.Dispatch<React.SetStateAction<string | File>>,
        isTemp: boolean,
        setIsTemp: React.Dispatch<React.SetStateAction<boolean>>
    }) => {
    const [showEmojiPicker, setShowEmojiPicker] = useState<boolean>(false);
    const [isOpenMoreOptions, setIsOpenMoreOptions] = useState<boolean>(false);
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const cameraInputRef = useRef<HTMLInputElement>(null);
    const [showTooltip, setShowTooltip] = useState<boolean>(false);
    const textarea = textareaRef.current;
    const textValue = typeof text === "string" ? text : "";
    const trimmedText = textValue.trim();
    const validationResult = validateField(trimmedText, { field: "Message" });
    const hasValidationError = Boolean(validationResult.error && trimmedText);

    const handleInput = () => {
        if (textarea) {
            textarea.style.height = "auto";
            textarea.style.height = `${textarea.scrollHeight}px`;
        }
    };

    const handleEmojiMessage = (emojiObject: any) => {
        setText(prevMessage => prevMessage + emojiObject.emoji);
    };

    const handleOpenEmoticons = () => {
        setIsOpenMoreOptions(false);
        setShowEmojiPicker(!showEmojiPicker);
    };

    const handleOpenMoreOptions = () => {
        setShowEmojiPicker(false);
        setIsOpenMoreOptions(!isOpenMoreOptions);
    };

    const handleSelectedFile = async (file?: File | null, reset?: () => void) => {
        setIsOpenMoreOptions(false);
        if (!file) return;
        const fileSizeMB = file.size / 1024 / 1024;
        if (fileSizeMB > 5) {
            setShowTooltip(true);
            reset?.();
            setTimeout(() => setShowTooltip(false), 3000);
            return;
        }
        const fileCompress = await compressImage(file, {
            quality: 0.7,
            maxWidth: 1280,
            maxHeight: 1280,
        });
        setText(fileCompress);
        reset?.();
    };

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        await handleSelectedFile(file, () => {
            e.target.value = "";
        });
    };

    useEffect(() => {
        if (textareaRef.current && window.innerWidth > 769) {
            textareaRef.current.focus();
        }
    }, []);

    const handleSendMessage = () => {
        if (!trimmedText || hasValidationError) return;
        onSendMessage();
        if (textarea) textarea.style.height = "auto";
        if (textareaRef.current) textareaRef.current.focus();
    };

    return (
        <>
            {showTooltip && (
                <div className="absolute bottom-20 md:bottom-24 w-52 md:w-60 left-1/2 transform -translate-x-1/2 bg-red-500 text-white px-4 py-2 rounded-md z-50">
                    <TextComponent variant="nh6">
                        The file must be smaller than 5MB
                    </TextComponent>
                </div>
            )}
            {text instanceof File && (
                <dialog
                    className=" z-[10] bg-[#fff] w-full fixed md:absolute inset-0 flex-grow h-full flex items-center justify-center"
                    open
                >
                    <Column
                        className="gap-5 rounded-lg flex-grow shadow-lg p-4 h-full relative"
                        mainAxisAlignment="center"
                        crossAxisAlignment="center"
                    >
                        <img
                            src={URL.createObjectURL(text)}
                            alt="Selected img"
                            className="w-[90%] h-[70%] object-contain"
                        />
                        <button
                            className="absolute top-10 right-6 text-gray-600 hover:text-red-500"
                            onClick={() => { setText(""); setIsTemp(false); }}
                        >
                            <XCloseGray />
                        </button>
                        <Row className="absolute bottom-10 left-6 gap-2 md:gap-5">
                            {["No timeout", "30 seconds"].map((label, index) => {
                                const isActive = index === 1 ? isTemp : !isTemp;
                                return (
                                    <CustomButton
                                        key={label}
                                        className="text-primary hover:text-pink gap-2"
                                        onClick={() => setIsTemp(!!index)}
                                        color={isActive ? "primary" : "white"}
                                        small>
                                        {isActive ? <TimeBG  /> : <Time />}
                                        <TextComponent variant="h6">{label}</TextComponent>
                                    </CustomButton>
                                );
                            })}
                        </Row>
                        <button
                            className="text-primary bg-primary rounded-full hover:text-pink absolute bottom-10 right-6"
                            aria-label="Send Message"
                            onClick={handleMessagePhoto}
                        >
                            <SendMessage />
                        </button>
                    </Column>
                </dialog>
            )}
            <Row
                className="z-[2] w-full shrink-0 px-4 pb-4 md:px-6 md:pb-6 gap-2 md:gap-4"
                crossAxisAlignment="end"
            >
                <Row
                    className="relative bg-white shadow-lg gap-4 p-4 rounded-lg"
                    crossAxisAlignment="end"
                >
                    <button
                        className={`text-grayLight2 hover:text-primary transition-transform duration-300 ${!isOpenMoreOptions ? "rotate-45 " : "rotate-[360deg]  text-primary"}`}
                        aria-label="More Options"
                        onClick={handleOpenMoreOptions}
                    >
                        <XCloseGray />
                    </button>
                    <DropDown
                        className="absolute left-0 bottom-[3.5rem]"
                        condition={isOpenMoreOptions}
                        options={[
                            { text: "Photos", icon: <Picture />, onClick: () => fileInputRef.current?.click() },
                            { text: "Camera", icon: <CameraPublic />, onClick: () => cameraInputRef.current?.click() },
                        ]}
                    />
                    <input
                        type="file"
                        ref={fileInputRef}
                        className="hidden"
                        accept=".jpg, .jpeg, .png"
                        onChange={handleFileChange}
                    />
                    <input
                        type="file"
                        ref={cameraInputRef}
                        className="hidden"
                        accept="image/*"
                        capture="environment"
                        onChange={handleFileChange}
                    />
                    <textarea
                        ref={textareaRef}
                        className="w-full max-h-[60px] text-base md:text-sm resize-none placeholder:text-grayLight2 placeholder:select-none outline-none"
                        rows={1}
                        onInput={handleInput}
                        onChange={(e) => setText(e.target.value)}
                        onKeyDown={(e: React.KeyboardEvent<HTMLTextAreaElement>) => {
                            if (e.key === "Enter" && !e.shiftKey) {
                                e.preventDefault();
                                handleSendMessage();
                            }
                        }}
                        value={(typeof text === "string" ? text : "")}
                        aria-label="Type Message"
                        placeholder="Type message..."
                    />
                    <button
                        className={`max-md:hidden text-grayLight2 hover:text-primary ${showEmojiPicker && "text-primary"}`}
                        aria-label="Open Emoticons"
                        onClick={handleOpenEmoticons}
                    >
                        <Emoticon />
                    </button>
                    {showEmojiPicker &&
                        <div
                            className="customEmojiPicker absolute bottom-[3.5rem] right-0 z-[2] h-96"
                        >
                            <EmojiPicker
                                onEmojiClick={handleEmojiMessage}
                                emojiStyle={EmojiStyle.NATIVE}
                                width="100%"
                                height="100%"
                                previewConfig={{ showPreview: false }}
                            />
                        </div>
                    }
                    {/* <button
                        className="text-grayLight2 hover:text-primary"
                        aria-label="Record Audio"
                    >
                        <MicroPhone />
                    </button> */}
                </Row>
                <button
                    className={`drop-shadow-lg rounded-full ${trimmedText && !hasValidationError ? "bg-primary" : "bg-grayLight"}`}
                    aria-label="Send Message"
                    onClick={handleSendMessage}
                    disabled={!trimmedText || hasValidationError}
                >
                    <SendMessage className="text-primary duration-300 transition-colors ease-in-out hover:text-primaryDark " />
                </button>
            </Row>
            {hasValidationError && (
                <div className="px-4 pb-4 md:px-6">
                    <TextComponent variant="nh7" className="text-red-500">
                        {validationResult.error}
                    </TextComponent>
                </div>
            )}
        </>
    );
};
